import Helper from './helper.js';
import Reevoo from './reevoo.js';


export default class Analytics {
    constructor(){
        this.bind();
        this.reevoo = new Reevoo();

    }

    bind(){
        document.addEventListener('click', (e) => this.target(e)?.matches('a:not(.analyticsEvent)') ? this.trackGeneric(e) : null);
        document.addEventListener('click', (e) => this.target(e)?.matches('.analyticsEvent:not(.reevooBadgeHolder)') ? this.trackCustom(e) : null);
        document.addEventListener('change', (e) => this.target(e)?.matches('.analyticsEvent:not(.reevooBadgeHolder)') ? this.trackCustom(e) : null);
        document.addEventListener('click',  (e) => this.target(e)?.matches('a[data-target=\"external\"]') ? this.windowOpen(e, this.target(e).href) : null);
    }

    push(data){
        if(data){ dataLayer.push(data); }
    }

    getEventData(el){
        const data = el ? el.dataset.analytics : null;
        if(data){ try { return JSON.parse(data.replace(/\'/g, '\"')); } catch { return null; } }
    }

    getAnalyticsFromSelector(el) {
       return getEventData(el);
    }

    windowOpen(e, location){
        if(location){
            e.preventDefault();
            window.open(location);
        }
    }

    windowLocation(e, location){
        if(location){
            e.preventDefault();
            setTimeout(() => window.location.href = location, 100);
        }
    }

    trackGeneric(e){
        const el = this.target(e);
        if(Helper.isFileLink(el)) { this.trackFileLink(e, el); }
        else if(Helper.isExternalLink(el)){ this.trackExternalLink(e, el); }
    }

    trackFileLink(e, el){
        if(el.closest('.orderBrochureDownloadList')){ return; }
        const extension = Helper.linkExtension(el);
        this.push({ 'event': 'Download link', 'eventCategory': dataLayer[0].pageTitle, 'eventAction': extension.toUpperCase(), 'eventLabel': el.href });
        if (extension.toLowerCase() !== 'pdf') { this.windowLocation(e, el.href); }
    }

    trackExternalLink(e, el){
        this.push({ 'event': 'Outbound link', 'eventCategory' : dataLayer[0].pageTitle, 'eventAction': el.text, 'eventLabel': el.href });
        if(el.dataset.target !== 'external') { this.windowOpen(e, el.href); }
    }

    trackCustom(e){
        e.preventDefault();
        const el = this.target(e);
        if(e.type === 'keydown' && e.keyCode !== 13) { return; }
        if(el.matches('input[type=checkbox]') && (e.type === 'change' || !el.checked)) { return; }

        const data = this.getEventData(el);
        this.push(data);
        if(this.shouldOpen(el)){  this.windowOpen(e, el.href) }
        else if(this.shouldRedirect(el)) { this.windowLocation(e, el.href); }
    }

    shouldOpen(el) {
        return Helper.isExternalLink(el) && 
            el.dataset.target !== 'external' && 
            !el.classList.contains('analyticsSameWindow') &&
            !el.classList.contains('analyticsPreventDefaultEvent');
    }

    shouldRedirect(el){
        return el.hasAttribute('href') &&
        el.getAttribute('href') !== "#" &&
        el.dataset.target !== "external" &&
        !el.classList.contains('reevooBadgeHolder') &&
        !el.classList.contains('analyticsPreventDefaultEvent');
    }

    target(e){
        return e.target?.closest('a');
    }
}

window.HONDA = window.HONDA || {};
window.HONDA.analytics = new Analytics();